import { REPORT_END_DATE_STORAGE, REPORT_START_DATE_STORAGE } from "../actions/dateData.action";

const initialState={
    startDate:'',
    endDate:''
}

export default function DateDataStorage(state = initialState, action) {
    const {type,payload} = action;

    switch (type) {
        case REPORT_START_DATE_STORAGE:
            return {
                ...state,
                startDate:payload
            }
        case REPORT_END_DATE_STORAGE:
            return {
                ...state,
                endDate:payload
            }
        default:
            return state
    }
}